import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

const msInSecond = 1000;
const msInMinute = 60 * 1000;
const msInAHour = 60 * msInMinute;
const msInADay = 24 * msInAHour;

const getPartsofTimeDuration = (duration) => {

    let days = 0;
    let hours = 0;
    let minutes = 0;
    let seconds = 0;

    if(duration > 0){
         days = Math.floor(duration / msInADay);
         hours = Math.floor((duration % msInADay) / msInAHour);
         minutes = Math.floor((duration % msInAHour) / msInMinute);
         seconds = Math.floor((duration % msInMinute) / msInSecond);
    }

    return { days, hours, minutes, seconds };
};

const Timer = (endDateTime) => {
    const { t } = useTranslation();

    const [time, setTime] = useState(new Date().toLocaleTimeString());

    useEffect(() => {
        const timeout = setTimeout(() => {
            const date = new Date();
            setTime(date.toLocaleTimeString());
        }, 1000);
        return () => {
            clearTimeout(timeout);
        };
    }, [time]);

    const now = Date.now(); // Number of milliseconds from begining of time

    const future = new Date(endDateTime.endDateTime); // The day we leave for Japan

    const timeDif = future.getTime() - now;
    
    const timeParts = getPartsofTimeDuration(timeDif);
    return (
        <>
            <div className="deals-countdown">
                <span className="countdown-section">
                    <span className="countdown-amount hover-up" suppressHydrationWarning>
                        {timeParts.days}
                    </span>
                    <span className="countdown-period"> {t("days")} </span>
                </span>
                <span className="countdown-section">
                    <span className="countdown-amount hover-up" suppressHydrationWarning>
                        {timeParts.hours}
                    </span>
                    <span className="countdown-period"> {t("hours")} </span>
                </span>
                <span className="countdown-section">
                    <span className="countdown-amount hover-up" suppressHydrationWarning>
                        {timeParts.minutes}
                    </span>
                    <span className="countdown-period"> {t("mins")} </span>
                </span>
                <span className="countdown-section">
                    <span className="countdown-amount hover-up" suppressHydrationWarning>
                        {timeParts.seconds}
                    </span>
                    <span className="countdown-period"> {t("sec")} </span>
                </span>
            </div>
        </>
    );
};

export default Timer;
